/**
 * Eine MaterialFactory, die Materialnamen austauschen oder modifizieren kann und die evtl. geänderten Namen an die eigentliche
 * MaterialFactory weiterleitet.
 *
 * Bei Verwendung der ReplacingMaterialFactory muss man über Caching nachdenken (z.B. cacheKey bei UniversalLoader.loadModelPromise setzen)
 */
export default class ReplacingMaterialFactory {

    /**
     * @param {(Array<Object> | ?Object)} materialNameReplacingMap ein Objekt (oder ein Array von Maps) dessen Keys die Namen der auszutauschenden Materialien und deren
..   *     Values die Ersetzungen sind. Beispiel {'CHANGE': 'CONCRETE'}. Statt eines Austausch-Namens kann auch ein Objekt verwendet werden
           der Form { instead: "austauschname", color: THREE.Color }, welche das Material sowohl austauschen als auch modifizieren kann.
           Dabei sind instead und color optional.
     * @param {Object} delegateMaterialFactory an diese Instanz wird die eigentliche Materialerzeugung weitergeleitet
     * @param {*} [cacheMap=new Map()]
     */
    constructor(materialNameReplacingMap, delegateMaterialFactory, cacheMap=new Map()) {
        this.cacheMap = cacheMap;
        if (materialNameReplacingMap==null) {
            this.materialNameReplacingMaps = [];
        } else if (_.isArray(materialNameReplacingMap)) {
            this.materialNameReplacingMaps = materialNameReplacingMap.filter(x=>x!=null);
        } else {
            this.materialNameReplacingMaps = [materialNameReplacingMap];
        }
        this.delegateMaterialFactory = delegateMaterialFactory;
    }

    /**
     * Erzeugt bzw. tauscht ein Material aus
     */
    create(materialName) {
        if (materialName=='WPC_CHANGE') {
            // debugger;
        }

        if (materialName==""){
            materialName="default";
        }
        let instead = materialName;
        let color = null;
        let modify = false;
        const mnrml = this.materialNameReplacingMaps.length-1;
        const originalNames=[];
        for (let i = mnrml; i>=0; i--) {
            let entry = this.materialNameReplacingMaps[i][instead];
            while (entry != null) {
                const old=instead;
                originalNames.push(old);
                if (_.isString(entry) && entry != '') {
                    instead = entry;
                }
                if (entry.instead) {
                    instead = entry.instead;
                }
                if (entry.color) {
                    color = entry.color;
                    modify = true;
                }
                if (old==instead){
                    break;
                }
                entry = this.materialNameReplacingMaps[i][instead];
            }
        }
        let original = this.delegateMaterialFactory.create(instead);
        if (original) {
            original=original.clone();
            original.userData.originalName=materialName;
            original.userData.originalNames=originalNames;
        }
        if (!modify) {
            return original;
        }
        let cacheKey = instead+'.'+color;
        let clone = this.cacheMap.get(cacheKey);
        if (!clone) {
            if (!original) {
                return null;
            }
            clone = original.clone();
            clone.needsUpdate = true;
            if (color!=null) {
                clone.color = color;
            }
            this.cacheMap.set(cacheKey,clone);
        }
        return clone;
    }

    /**
     * löscht den Materialien-Cache
     */
    clearMaterialsCache() {
        this.delegateMaterialFactory.clearMaterialsCache();
        this.cacheMap.clear();
    }

    /** */
    getAllKnownMaterialNames() {
        return this.delegateMaterialFactory.getAllKnownMaterialNames();
    }

}
